import React, { useState } from 'react';

const AsystoPage = () => {
  const [loading, setLoading] = useState(true);

  return (
    <section className="bg-[#fff] pt-16 px-4 min-h-screen relative">
      <div className="max-w-6xl mx-auto text-center mb-12">
        <p className="text-[#d2a391] text-sm tracking-[0.2em] mb-2">
          PSYCHOTERAPIA Marciniec
        </p>
        <h2 className="text-3xl md:text-5xl font-alike text-darkGrey">
          Zobacz, w czym możemy Ci pomóc
        </h2>
      </div>

      {/* Loader */}
      {loading && (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
          <div className="w-12 h-12 border-4 border-[#d2a391] border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}

      <div className="w-full flex justify-center overflow-x-auto relative z-0">
        <iframe
          id="asysto_iframe"
          src="https://imarciniec.asysto.pl/rezerwacja"
          onLoad={() => setLoading(false)}
          className="w-[100%] border-0"
          style={{ minHeight: '820px', maxHeight: '2000px' }}
          title="Rezerwacja Asysto"
        />
      </div>

      <script
        dangerouslySetInnerHTML={{
          __html: `
            window.addEventListener("message", function(e) {
              if (e.data.hasOwnProperty("iframe_height")) {
                document.getElementById("asysto_iframe").style.height = e.data.iframe_height + "px";
              }
            });
          `,
        }}
      />
    </section>
  );
};

export default AsystoPage;
